import AxiosClient from './axios-client';
export default AxiosClient;